/*
 * Copyright (c) 2025, Wultra s.r.o. (www.wultra.com).
 *
 * All rights reserved. This source code can be used only for purposes specified
 * by the given license contract signed by the rightful deputy of Wultra s.r.o.
 * This source code can be used only by the owner of the license.
 *
 * Any disputes arising in respect of this agreement (license) shall be brought
 * before the Municipal Court of Prague.
 */

import { ApplicationDetailViewModel } from "../features/application-detail/application-detail-viewmodel"

import type { ViewModelContainer } from "./viewmodel"

export const applicationDetailViewModelLookup =
    (provider: ViewModelContainer): ((id: number) => ApplicationDetailViewModel) =>
    (id: number) =>
        provider.getViewModel(ApplicationDetailViewModel, id)
